// lazyComponents.js
import React from "react";

// Lazy loading components
export const Home = React.lazy(() => import("./components/Home/Home"));
export const Login = React.lazy(() => import("./components/Login/Login"));
export const Forgot = React.lazy(() => import("./components/Password/Forgot"));
export const Reset = React.lazy(() => import("./components/Password/Reset"));
export const Register = React.lazy(() => import("./components/Login/Register"));
export const Prices = React.lazy(() => import("./components/Prices/Prices"));
export const FAQ = React.lazy(() => import("./components/FAQ/FAQ"));
export const About = React.lazy(() => import("./components/About/About"));
export const Services = React.lazy(() => import("./components/Services/Services"));
export const Clients = React.lazy(() => import("./components/Clients/Clients"));
export const Help = React.lazy(() => import("./components/Help/Help"));
export const PrivacyPolicy = React.lazy(
  () => import("./components/PrivacyPolicy/PrivacyPolicy"),
);
export const TermsOfService = React.lazy(
  () => import("./components/TermsOfService/TermsOfService"),
);
export const CookiePolicy = React.lazy(
  () => import("./components/CookiePolicy/CookiePolicy"),
);
export const ContactUs = React.lazy(
  () => import("./components/Contactus/Contactus"),
);
export const Download = React.lazy(
  () => import("./components/Download/Download"),
);
export const UserGroups = React.lazy(
  () => import("./components/UserGroups/UserGroups"),
);
export const AddUserGroup = React.lazy(
  () => import("./components/UserGroups/AddUserGroup"),
);
export const NotificationsList = React.lazy(
  () => import("./components/Notifications/NotificationsList"),
);
export const ClientLogin = React.lazy(
  () => import("./components/ClientPortal/ClientLogin"),
);
export const ClientPortalHome = React.lazy(
  () => import("./components/ClientPortal/ClientPortalHome"),
);
export const ClientProfile = React.lazy(
  () => import("./components/ClientPortal/ClientProfile"),
);
export const ProfileSettings = React.lazy(
  () => import("./components/Profile/Settings"),
);
export const ChangePassword = React.lazy(
  () => import("./components/Profile/ChangePasswordPage"),
);
export const Checkout = React.lazy(() => import("./components/Cart/Checkout"));
export const MySubscription = React.lazy(
  () => import("./components/Subscription/MySubscription"),
);
export const MyBilling = React.lazy(
  () => import("./components/Subscription/MyBillingPage"),
);
export const MySubscriptions = React.lazy(
  () => import("./components/Subscription/MySubscriptionsPage"),
);
export const OwnedCompanies = React.lazy(
  () => import("./components/Subscription/OwnedCompaniesPage"),
);
export const DomainManagement = React.lazy(
  () => import("./components/Subscription/DomainManagementPage"),
);
export const MyInvoices = React.lazy(
  () => import("./components/Subscription/MyInvoicesPage"),
);
export const MyOrders = React.lazy(
  () => import("./components/Subscription/MyOrdersPage"),
);
export const MyTasks = React.lazy(
  () => import("./components/Subscription/MyTasksPage"),
);
export const MyDocuments = React.lazy(
  () => import("./components/Subscription/MyDocumentsPage"),
);
export const MyKnowledge = React.lazy(
  () => import("./components/Subscription/MyKnowledgePage"),
);
export const MyBackupRestore = React.lazy(
  () => import("./components/Subscription/MyBackupRestorePage"),
);
export const MySupportTickets = React.lazy(
  () => import("./components/Subscription/MySupportTicketsPage"),
);
